import React from 'react';

function TabPanel({
  children, id, index, value, isDisabled = false, style = {},
}) {
  return (
    <div
      id={`${id}-${index}`}
      aria-labelledby={`${id}-${index}`}
      hidden={value !== index}
      style={isDisabled ? { pointerEvents: 'none', opacity: 0.6 } : style}
    >
      {children}
    </div>
  );
}

export default React.memo(TabPanel);
